export const ADD_PATIENT_MSG_SUCCESS = "Пациент успешно добавлен";
export const ADD_PATIENT_MSG_FAILURE =
  "При добавлении пациента произошла ошибка";
